import { formatUnits } from '@ethersproject/units'
import axios from 'axios'

axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'
export const getLGFBalanceTransfers = response => {
    var balanceIN = 0
    var balanceOUT = 0

    response.data.data.data.items.map(item => {
        balanceIN += parseFloat(
            item.transfers[0].transfer_type === 'IN'
                ? formatUnits(item.transfers[0].delta, 9)
                : 0
        )

        balanceOUT += parseFloat(
            item.transfers[0].transfer_type === 'OUT'
                ? formatUnits(item.transfers[0].delta, 9)
                : 0
        )

        return null
    })

    return [parseFloat(balanceIN).toFixed(0), parseFloat(balanceOUT).toFixed(0)]
}

export const getLGFItem = response => {
    var itemToReturn

    response.data.data.items.map(item => {
        if (
            item.contract_address ===
            '0x934c1ff0bed280f3041ff7e3131b156f45ac8b5c'
        ) {
            itemToReturn = item
        }
    })
    return itemToReturn
}

export async function coingeckoETH() {
    try {
        return await axios.get(
            `https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd%2Ceur%2Cbtc%2Ceth`
        )
    } catch (error) {
        // eslint-disable-next-line
        console.error(error.message)
    }
    return null
}
